import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe for displaying file-type-specific icons that transforms a file name into the corresponding icon path based on the file extension.
 *
 * @example
 * ```html
 * <app-all-icons [iconNameAndStyling]="(folder.title | fileTypeIcon) + '; icon-size-1p25'"/>
 * ```
 */
@Pipe({
  name: 'fileTypeIcon',
  pure: true,
  standalone: true,
})
export class FileTypeIconPipe implements PipeTransform {
  transform(fileName: string): string {
    const iconPath = this.getIconPath(fileName);
    return iconPath;
  }

  /**
   * In the box tree there are files and folders
   * with the image on the left site.<p>
   * Based on the file extension, the correct image is shown.
   *
   * @param fileName is the full name of the file.
   * @return the path to the file in '/assets/optimised'
   */
  private getIconPath(fileName: string): string {
    const fileExtensionRE = /(?:\.([^.]+))?$/;
    const fileExtension = fileExtensionRE.exec(fileName)[1];
    switch (fileExtension) {
      case 'pdf':
        return 'box/pdf.svg';
      case 'docx':
        return 'box/word.svg';
      case 'doc':
        return 'box/word.svg';
      case 'xlsx':
        return 'box/excel.svg';
      case 'ppt':
        return 'box/powerpoint.svg';
      case 'pptx':
        return 'box/powerpoint.svg';
      case undefined:
      default:
        return 'box/file.svg';
    }
  }
}
